<template>
	<div class="items">
		<p class="form_title">
			客户信息
		</p>
		<el-form label-width="100px" :model="userDate" v-if="userDate.cust"  ref="formRef">
			<!-- <el-form-item label="客户名称" prop="name">
				<el-input v-model="formData.cust.name" placeholder="请输入客户名称" />
			</el-form-item>
			<el-form-item label="手机号" prop="phone">
				<el-input v-model="user_form.phone" placeholder="请输入手机号" maxlength="11"
				/>
			</el-form-item>
			<el-form-item label="客户邮箱">
				<el-input v-model="user_form.email" placeholder="请输入邮箱" />
			</el-form-item>
			<el-form-item label="身份证">
				<el-input v-model="user_form.idcard" placeholder="请输入身份证号码" />
			</el-form-item> -->
			<el-form-item label="城市" :rules="[{required: false, message: '请输入客户位置', trigger: 'blur'}]">
				<el-cascader v-model="userDate.cust.adcode"   :props="{ expandTrigger: 'hover', value: 'adcode', emitPath: false }" :options="cityOptions" 
				placeholder="请选择省市区" style="width: 100%" clearable />
			</el-form-item>
			<!-- <el-form-item label="满意度">
				<el-input-number v-model="user_form.satisfaction" :min="1" :max="10" label="满意度"
				/>
			</el-form-item> -->
			<el-button type="primary" @click="saveCustInfo">提交</el-button>
		</el-form>
	</div>
	
</template>

<script>
	import request from '../utils/request'
	
	// 常用正则
	const phoneReg = /^1[3-9]\d{9}$/
	const emailReg = /^[\w.-]+@[\w.-]+\.\w+$/
	const idcardReg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
	export default {
		 props: {
		    formData: {
		      type: Object,
		      required: true,
		      default: () => ({}) // 默认值
		    }
		  },
		data(){
			return {
				cityOptions: [],
				data:"320200",
				// cityOptions: provinceAndCityData,
				userDate :{},
				user_form: {
					name: '',
					phone: '',
					email: '',
					idcard: '',
					city: [],
					satisfaction: 1
				},
				user_rules: {
				
					city: [{
						required: true,
						message: '请输入城市',
						trigger: 'blur'
					}],
					
				},
			}
		},
		 watch: {
		    formData: {
		      handler(newVal) {
				this.userDate = newVal;
				 this.$forceUpdate();
		      },
		      deep: true // 深度监听对象内部变化
		    }
		  },
		   mounted() {
			  this.userDate =  this.formData;
			 
		    },
			created() {
			this.loadAdcodeTree();	
			},
			methods: {
				/**
				 * 保存客户信息
				 */
				saveCustInfo(){
			
				  const res = request.post('/applets/qywx/save_cust', this.userDate)
				  .then(response => {
						 this.$message({
						          message: '保存成功',
						          type: 'success'
						        });
				  
				  })
				  .catch(error => {
				    console.error('请求失败:', error)
				    return null // 返回默认值，避免链式调用中断
				  })
				},
				/**
				 * 获取行政区划树形结构
				 */
				loadAdcodeTree() {
				  const res = request.get('/applets/qywx/adcodeTree?maxLevel=1')
				  .then(response => {
				    console.log('请求成功:', response.data)
				    this.cityOptions = response.data;
				    // 确保localMsg在当前作用域内已定义（解决潜在的问题2）
				    // if (localMsg && localMsg.value !== undefined) {
				    //   localMsg.value = response.data
				    // }
				  })
				  .catch(error => {
				    console.error('请求失败:', error)
				    return null // 返回默认值，避免链式调用中断
				  })
				},
				
		   }
	}
	
</script>

<style>
	.items{
		/* text-align: left; */
	}
</style>